import { useState } from "react";
import { Checkbox, Tooltip } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import CallIcon from "@mui/icons-material/Call";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import DateRangeIcon from "@mui/icons-material/DateRange";
import ScheduleIcon from "@mui/icons-material/Schedule";
import BadgeIcon from "@mui/icons-material/Badge";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import GetAppRoundedIcon from "@material-ui/icons/GetAppRounded";
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { MBContract } from "../../../constants/insurance/constant";
import { STATUS_CODE_MAP } from "../../../constants/provider/constant";
import ActionsCellEsale from "./actions-cell-esale";

const NameTitles = ['mr', 'ms', 'mrs'];
function intersect(a, b) {
  var setB = new Set(b);
  return [...new Set(a)].filter(x => setB.has(x));
}

const CardAccordionEsale = ({
  isSelected,
  handleClick,
  row,
  index,
  getReports,
  status,
  pageName,
  handleClickOpencustomerAttendance,
  handleClickOpenShowCommunicationHistory,
  handleClickOpenConfirmAppointment,
  handleClickOpendocumentSubmission
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const isItemSelected = isSelected(row.rowData);
  const labelId = `enhanced-table-checkbox-${index}`;
  const {
    eQuote,
    name,
    state,
    createdOn,
    createdTime,
    city,
    email,
    phoneNo,
    corporatename,
  } = row;
  let shortName = name?.split(' ');
  if(shortName?.length && intersect(shortName, NameTitles)?.length) {
    shortName = `${shortName[1]} ${shortName[2] ? shortName[2][0] : ''}`;
  } else {
    shortName = `${shortName[0]} ${shortName[1] ? shortName[1][0] : ''}`;
  }
  return (
    <>
      <div className="appointment-card-wrapper pd-xs-15">
        <div
          role="button"
          onClick={(evt) => {
            evt.stopPropagation();
            setIsVisible((val) => !val);
          }}
          className="card-first-row flex js-sp-bt-xs al-itm-ctr"
        >
          {["confirmed", "notAttended", "pending"].includes(status) ? <div>
            <Checkbox
              className="pd-xs-0 "
              color="primary"
              onClick={(event) => {
                event.stopPropagation();
                handleClick(event, row.rowData);
              }}
              checked={isItemSelected}
              disabled={
                (row.rowData.currentStatusId !== STATUS_CODE_MAP["Not Attended"]
                  ? false
                  : true) ||
                (row.rowData.currentStatusId !==
                  STATUS_CODE_MAP["Customer awaited at DC"] &&
                  pageName?.length && pageName.includes(status))
              }
              inputProps={{
                "aria-labelledby": labelId,
              }}
            />
          </div> : <></>}
          <div
            // onClick={(event) => {
            //   event.stopPropagation();
            //   redirectToHistory(event, row.requestid);
            // }}
            className="text-blue-600 font-semibold cursor-pointer"
          >
            <b>{eQuote}</b>
          </div>
          <div className="flex al-itm-ctr">
            <PersonIcon /> <b>{shortName ? shortName : name}</b>
          </div>
          <div className="text-gray-500 text-xs flex al-itm-ctr" role="button" onClick={(evt) => evt.stopPropagation()}>
            <CallIcon /> <a href={`tel:${phoneNo}`}>{phoneNo}</a>
          </div>
          <div>
            {isVisible ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </div>
        </div>

        {isVisible ? (
          <div className="card-accordion-row">
            <div className="flex js-sp-bt-xs pd-tp-xs-5">
              <b>{email}</b>
            </div>
            <div className="flex js-sp-bt-xs pd-tp-xs-5 text-blue-600">
              <div className="flex al-itm-ctr">
                
              </div>
            </div>
            <div className="flex js-sp-bt-xs pd-tp-xs-5">
              <div>
                <DateRangeIcon />
                {createdOn}
              </div>
              <div>
                <ScheduleIcon />
                {createdTime}
              </div>
            </div>
            <div className="flex js-sp-bt-xs pd-tp-xs-5">
              <div className="flex al-itm-ctr  pd-rt-xs-5">
                <BusinessIcon /> {corporatename}
              </div>
            </div>
            <div className="flex js-sp-bt-xs pd-tp-xs-5">
              <div className="flex al-itm-ctr">
                {/* <BadgeIcon /> */}
                {city}, {state}
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        <div className="flex js-sp-bt-x pd-tp-xs-15 al-itm-strt">
          <ActionsCellEsale
            status={status}
            row={row}
            pageName={pageName}
            handleClickOpenShowCommunicationHistory={
              handleClickOpenShowCommunicationHistory
            }
            handleClickOpenConfirmAppointment={
              handleClickOpenConfirmAppointment
            }
            handleClickOpendocumentSubmission={handleClickOpendocumentSubmission}
          />
        </div>
      </div>
    </>
  );
};

export default CardAccordionEsale;
